import { ModelEntityReference, ModelEntityType } from './types';

export function canHaveMultipleTimeVersions(type: ModelEntityType) {
  return type === ModelEntityType.GROUP || type === ModelEntityType.PORTFOLIO || type === ModelEntityType.COMPANY;
}

export function isProductLike(type: ModelEntityType) {
  return type === ModelEntityType.PRODUCT || type === ModelEntityType.MIXIN || type === ModelEntityType.PHENOMENON;
}

export function isSameModelEntity(a: ModelEntityReference, b: ModelEntityReference) {
  return a.type === b.type && a.id === b.id;
}
